import React, { useState } from "react";
import { Tab } from "@material-ui/core";
import { StyledModuleNavigation } from "./StyledModuleNavigation";
import QueryNListView from "../../modules/Views/Query/QueryNListView";

function ModuleNavigation(props) {
  const [value] = useState(0);

  return (
    <>
      <StyledModuleNavigation value={value}>
        <Tab className="active-nav-tab"
             label="Public Security Terms (Niederlegungsverzeichnis gemäß §5 eWpG)"
             disabled/>
      </StyledModuleNavigation>

      <QueryNListView />
    </>
  );
}

export default ModuleNavigation;
